import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsCard = ({ title, value, subtitle, icon, trend, trendValue, color = 'primary' }) => {
  const getColorClasses = (colorType) => {
    const colors = {
      primary: 'bg-primary/10 text-primary border-primary/20',
      success: 'bg-green-100 text-green-600 border-green-200',
      warning: 'bg-yellow-100 text-yellow-600 border-yellow-200',
      error: 'bg-red-100 text-red-600 border-red-200',
      info: 'bg-blue-100 text-blue-600 border-blue-200'
    };
    return colors?.[colorType] || colors?.primary;
  };

  const getTrendColor = (trendType) => {
    return trendType === 'up' ? 'text-green-600' : trendType === 'down' ? 'text-red-600' : 'text-muted-foreground';
  };

  const getTrendIcon = (trendType) => {
    return trendType === 'up' ? 'TrendingUp' : trendType === 'down' ? 'TrendingDown' : 'Minus';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 hover:shadow-elevation-1 transition-standard">
      <div className="flex items-center justify-between mb-3">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center border ${getColorClasses(color)}`}>
          <Icon name={icon} size={20} />
        </div>
        
        {trend && trendValue && (
          <div className={`flex items-center space-x-1 text-xs ${getTrendColor(trend)}`}>
            <Icon name={getTrendIcon(trend)} size={12} />
            <span>{trendValue}</span>
          </div>
        )}
      </div>

      <div className="space-y-1">
        <h3 className="text-2xl font-bold text-foreground">{value}</h3>
        <p className="text-sm font-medium text-foreground">{title}</p>
        {subtitle && (
          <p className="text-xs text-muted-foreground">{subtitle}</p>
        )}
      </div>
    </div>
  );
};

export default StatsCard;